/**
 * Функция, которая сливает несколько рефов в один
 * @typeParam RefValue тип значения, которое хранится в рефе
 * @param refs рефы, которые нужно слить в один реф
 * @returns Возвращает реф-коллбэк, внутри которого передастся значение всем рефам-аргументам
 * @example
 * ```typescript
 *
 * const Example = forwardRef(function Example(
 *     {},
 *     ref
 * ) {
 *     const localRef = useRef(null)
 *     return (
 *         <div ref={mergeRefs(ref, localRef)} />
 *     )
 *```
 */
export function mergeRefs(...refs) {
    return (value) => {
        for (const ref of refs) {
            if (typeof ref === 'function') {
                ref(value);
            }
            else if (ref != null) {
                ref.current = value;
            }
        }
    };
}
